import React, { useCallback } from "react";
import { useDispatch } from "react-redux";
import EmptyModal from "../../components/modals/EmptyModal";
import { SnackbarData } from "../../components/Snackbar";
import { EmployeeProductionDialogContent } from "../../features/employeeProduction/components/EmployeeProductionDialogs";
import { ProductionRecipeTable } from "../../features/employeeProduction/components/ProductionRecipeTable";
import { ProductionScanForm } from "../../features/employeeProduction/components/ProductionScanForm";
import { useEmployeeProductionViewModel } from "../../features/employeeProduction/hooks/useEmployeeProductionViewModel";
import * as actions from "../../store/actions/index";

export default function ManufacturedProductsEmployee() {
  const dispatch = useDispatch();
  const logout = useCallback(() => {
    dispatch(actions.logout() as any);
  }, [dispatch]);
  const addSnackbar = useCallback(
    (snackbar: SnackbarData) => {
      dispatch(actions.addSnackbar(snackbar) as any);
    },
    [dispatch],
  );

  const { state, actions: productionActions } = useEmployeeProductionViewModel({
    logout,
    addSnackbar,
  });

  const dialogContent = (
    <EmployeeProductionDialogContent
      dialog={state.dialog}
      selectedLot={state.selectedLot}
      onClose={productionActions.closeDialog}
      onConfirmScan={productionActions.confirmScan}
      onConfirmEdit={productionActions.confirmEdit}
      onConfirmDelete={productionActions.confirmDelete}
      onEdit={productionActions.openEdit}
      onDelete={productionActions.openDelete}
    />
  );

  return (
    <div className="qatrace-screen qatrace-module-page px-4 sm:px-6 lg:px-8">
      <ProductionScanForm
        lots={state.lots}
        selectedLot={state.selectedLot}
        barcode={state.barcode}
        productionLoading={
          state.status === "initializing" ||
          state.status === "loading-production"
        }
        barcodeLoading={state.status === "looking-up-barcode"}
        onSelectProduction={productionActions.selectProduction}
        onBarcodeChange={productionActions.setBarcode}
        onScan={productionActions.scanBarcode}
      />

      {state.status === "loading-production" && (
        <p className="mt-4 text-sm text-gray-600">Fetching scanned items…</p>
      )}
      {state.status === "looking-up-barcode" && (
        <p className="mt-4 text-sm text-gray-600">Looking up barcode…</p>
      )}

      {state.selectedLot && state.status !== "loading-production" && (
        <ProductionRecipeTable
          items={state.recipeItems}
          expandedRows={state.expandedRows}
          onExpandedRowsChange={productionActions.setExpandedRows}
          onItemSelected={productionActions.openItemActions}
        />
      )}

      <EmptyModal
        childComponent={dialogContent}
        open={state.dialog.type !== "none"}
        setOpen={productionActions.closeDialog}
      />
    </div>
  );
}
